import { type ReactElement, type ReactNode } from 'react'
import cn from 'classnames'

interface PlaceholderBoxProps {
  additionalClasses?: string
  children: ReactNode
  loading: boolean
  rows: number
  rowHeight: string
}

export function PlaceholderBox ({ loading, children, rowHeight, rows, additionalClasses }: PlaceholderBoxProps): ReactElement {
  if (!loading) { return <div className="animate__animated animate__fadeIn">{children}</div> }
  return (
    <div className={cn('w-full animate-pulse animate__animated animate__fadeOut', additionalClasses)}>
      {
        Array.from(new Array(rows)).map((_x, i) => (
          <div key={i} className={cn('my-2 w-full bg-gray-200 opacity-80 rounded', rowHeight)} />
        ))
      }
    </div>
  )
}

PlaceholderBox.defaultProps = {
  rowHeight: 'h-2',
  rows: 3
}
